<div class="btList">
  @if (isLoading) {
  <div class="loadingSequence" aria-live="polite">
    <mat-spinner diameter="28"></mat-spinner>
    <span>Loading data...</span>
  </div>
  } @else {
  @if (hasLoadingError) {
  <div class="errorEntries">Failed to load data. Please try again later.</div>
  } @else {
  <mat-accordion>
    @for (task of tasks; track task) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>{{ task.name }} ({{ task.list.length }})</mat-panel-title>
      </mat-expansion-panel-header>

      <app-task-view-table [data]="task.list" />
    </mat-expansion-panel>
    }
  </mat-accordion>
  @if (tasks.length === 0) {
  <div class="noEntries">no Entries found</div>
  }
  }
  }
</div>
